'use strict'

var CannonController = require( '../../sharedjs/CannonController.js' );

var BurstBubbleParticles = require( './BurstBubbleParticles.js' );

var BubbleShader = require( './materials/BubbleShader.js' );

var normFromPoints = require( '../../sharedjs/normalFromPoints.js' );

var loadTex = require( './loadTex.js' );

var BubblesAudio = require( './BubblesAudio.js' );

var BubbleTexture = require( './BubbleTexture.js' );

var Bloom = require( './postProcess/BloomOverlay.js' );

var audioFix = require( './WebAudioFixes.js' )();

// var BubbleEnvTexture = require( './BubblesEnvTexture.js' );

var randf = THREE.Math.randFloat;
var remap = THREE.Math.mapLinear;
var clamp = THREE.Math.clamp;


// animation attributes
var attr = {

  goalWeight: 2,
  
  goal: new THREE.Vector3( 0, -130, 0 ),
  
  attenuation: 0.9,
  
  cam: {
    y: -400,
    rad: 200
  },
  
  bubble: {
  
    count: 130,

    radius: {
      max: 70,
      min: 10
    },
  
    life: {
      min: 6000,
      max: 20000
    },
  
    y: {
      min: -5000,
      max: -1250
    }
  },

  blast: {
    
    falloff: 100,

    vel: {
      max: 100,
      min: 0.1
    }
  }
}


// 
// action
// 
var Sketch = function(options){

  options = options || {};

  var container = options.container || $("#container");

  // three
  var view = new ThreeView(container);

  var renderer = view.setupRenderer({
    clearColor: 0xff0000
  });

  var clock = new THREE.Clock();

  var scene = new THREE.Scene();

  var camera = new THREE.PerspectiveCamera(60, view.aspect, 1, 10000);
  camera.position.y = attr.cam.y;
  camera.position.z = -600;

  var controls = new THREE.OrbitControls( camera, renderer.domElement );
  controls.enableZoom = false;
  controls.enableRotate = false;
  controls.enablePan = true
  controls.enableDamping = true;
  controls.dampingFactor = 0.5;
  controls.rotateSpeed = 0.5;


  controls.target.set(
    camera.position.x,
    attr.cam.y,
    0
  )

  

  // vars
  var elapsedTime = 0;
  var delta = new THREE.Vector3();


  // post processing
  var downSample = 0.25;
  var downSampleWidthScale = 1;
  var bloom = new Bloom(view.width * downSample * downSampleWidthScale, view.height * downSample, {
    iterations: 6,
    opacity: 0.75,
    blurScale: 1.05,
    blurstep: 1.25,
    hi: 0.95,
    lo: 0.75,
  });


  // audio
  var audio = BubblesAudio();


  // bubble texture
  var filmTex = BubbleTexture();

  
  // physics world
  var cc = CannonController({
    gravity: new CANNON.Vec3(0,0,0)
  });


  // Create a plane
  var ceilingBody = new CANNON.Body({
    material: new CANNON.Material({
      frictionEquationStiffness: 1,
      friction: 10.0
    })  ,
    mass: 0 //static
  });

  var ceilingShape = new CANNON.Plane();
  ceilingBody.addShape(ceilingShape);
  cc.world.addBody(ceilingBody);
  ceilingBody.quaternion.setFromAxisAngle({x:1, y: 0 ,z: 0}, Math.PI * .5)


  var baseBubble;
  var textureLoader = new THREE.TextureLoader();
  var texture1 = textureLoader.load( './assets/night360.jpg');
  var rampTex = textureLoader.load( './assets/ramp.png');

  var g = new THREE.SphereBufferGeometry(1, 40, 20);
  THREE.BufferGeometryUtils.computeTangents(g);

  baseBubble = new THREE.Mesh(
    g,
    new BubbleShader({
      map: filmTex.texture, 
      ramp: rampTex,
      envmap: texture1,
      side: 2
    })
  );

  var bubbleGroup = new THREE.Scene();
  scene.add( bubbleGroup );

  var bubbleCollisionMaterial = new CANNON.Material({
    friction: Infinity,
    restitution: 0,
  })

  var burst = new BurstBubbleParticles();
  scene.add(burst);

  function popBubble( b ){

    audio.pop( b );

    b.body.position.x = randf(-500,500);
    b.body.position.y = randf(attr.bubble.y.min, attr.bubble.y.max);
    b.body.position.z = randf(-350,350);

    b.body.velocity.scale(0);
    b.body.angularVelocity.scale(0);

    burst.pop(b.radius, b.position);

    b.timeout = setTimeout(function(){

      popBubble(this);

    }.bind(b), randf( attr.bubble.life.min, attr.bubble.life.max ));
  }


  function blastBubble( b ){

    audio.burst( b );

    popBubble( b );

    var delta = b.position.clone();
    var l = 0;
    var v = 0;

    // accelerate the other bubbles away from the pop
    bubbleGroup.children.forEach(function(s){
      
      if(s !== b){
      
        // get delta
        delta.copy(s.position)
          .sub(b.position);

        v = 1 - clamp(attr.blast.falloff / delta.length(), 0, 1);

        v = Math.pow(v, 2);

        v = remap(v, 0, 1, attr.blast.vel.max, attr.blast.vel.min);

        delta.normalize().multiplyScalar( v );

        s.body.velocity.x += delta.x;
        s.body.velocity.y += delta.y;
        s.body.velocity.z += delta.z;

      }
    });

  }



  function addSphere( pos ){

    var r = TWEEN.Easing.Cubic.Out(Math.random());
    r = remap(r, 0,1, attr.bubble.radius.min, attr.bubble.radius.max);

    // create the mesh
    var m = baseBubble.clone();
    m.material = m.material.clone();

    m.material.uniforms.map.value = filmTex.texture;
    m.material.uniforms.envmap.value = texture1
    m.material.uniforms.ramp.value = rampTex;

    m.position.copy( pos );
    m.scale.multiplyScalar( r );

    // rigid body
    m.body = cc.addSphere( r, {
      position: pos,
      mass: r * r,
      material: bubbleCollisionMaterial
    });

    m.radius = r;

    // add it to the bubbleGroup
    bubbleGroup.add(m);

    // add pop loop
    m.timeout = setTimeout(function(){
      popBubble(this);
    }.bind(m), randf( attr.bubble.life.min, attr.bubble.life.max ));
  }

  for(var i=0; i<attr.bubble.count; i++){
    
    addSphere( new THREE.Vector3(
      randf(-500,500),
      randf(attr.bubble.y.min,attr.bubble.y.max),
      randf(-350,350) ));

  }
  
  var camSphere = cc.addSphere(attr.cam.rad, {
    material: bubbleCollisionMaterial
  })

  // var testTorus = new THREE.Mesh(
  //   new THREE.TorusGeometry( 20, 15, 30, 30),
  //   new THREE.MeshNormalMaterial({
  //     wireframe: false,
  //     side: 0,
  //   }));

  // scene.add( testTorus );

  bubbleGroup.children[0].radius = attr.bubble.radius.max;
  bubbleGroup.children[0].scale.set(1,1,1).multiplyScalar( bubbleGroup.children[0].radius );

  bubbleGroup.children[0].body.shapes[0].radius = bubbleGroup.children[0].radius;


  view.update = function(){

    audioFix.onRAF();

    // testTorus.position.copy(bubbleGroup.children[0].position);
    // testTorus.quaternion.copy(bubbleGroup.children[0].quaternion);

    TWEEN.update();

    controls.update();

    elapsedTime = clock.getElapsedTime();

    cc.update(1/60);

    camSphere.position.copy( camera.position );


    // update the bubbles
    bubbleGroup.children.forEach( function( m ){

      m.material.uniforms.speed.value *= 0.975;
      m.material.uniforms.speed.value +=  0.025 * Math.min(1, m.body.velocity.length() / 1000);
    
      m.position.copy(m.body.position);
      m.quaternion.copy(m.body.quaternion);

      delta.copy(m.position)
        .sub(attr.goal)
        .normalize()
        .multiplyScalar( -attr.goalWeight );

      m.body.velocity.scale(attr.attenuation)

      m.body.velocity.x += delta.x;
      m.body.velocity.y += delta.y;
      m.body.velocity.z += delta.z;
    
    });

  }

  view.draw = function(){

    filmTex.draw(renderer, camera);

    bubbleGroup.children.forEach( function( b ){
      b.material.side = 1
    });

    renderer.render(scene, camera, null, true);


    bubbleGroup.children.forEach( function( b ){
      b.material.side = 0
    });
    renderer.render(bubbleGroup, camera, null, false);


    // bloom.render(renderer, scene, camera);
    bloom.render(renderer, scene, camera);

  }


  view.onResize = function(){
    camera.aspect = view.aspect;
    camera.updateProjectionMatrix();
    bloom.setSize( view.width * downSample * downSampleWidthScale, view.height * downSample );
  }


  // TODO: test on touch then add to baseSketch
  var mouse = new THREE.Vector2();
  var raycaster = new THREE.Raycaster();

  function onPress(e){

    mouse.x = ( (e.pageX || e.clientX) / window.innerWidth ) * 2 - 1;
    mouse.y = - ( (e.pageY || e.clientY) / window.innerHeight ) * 2 + 1;

    raycaster.setFromCamera( mouse, camera );

    var intersects = raycaster.intersectObjects( bubbleGroup.children );

    if(intersects.length){

      var hit = intersects[0];

      blastBubble( hit.object );

    }
    
  }

  container.on('click', onPress);


  return {
    begin: function(){
      view.begin();
    }
  }

}

window.onload = function() {

  var sketch = new Sketch();

  sketch.begin();

};
